import * as React from 'react'
import { ShopPage } from '@/types/sanity'
import { ShopPageViewWrapper } from './styles'
import { ShopPageProductBlock } from './ShopPageProductBlock'

interface ShopPageViewProps {
  shopPage: ShopPage
}

export const ShopPageView: React.FC<ShopPageViewProps> = ({ shopPage }) => {
  const products = shopPage.products || []
  return (
    <ShopPageViewWrapper>
      {products.map((productBlock, i) => (
        <ShopPageProductBlock
          key={`productBlock-${i}`}
          content={productBlock}
        />
      ))}
    </ShopPageViewWrapper>
  )
}
